

































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'
import TheClientChoiceTable from '@/views/kyc-form/component/TheClientChoiceTable.vue'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    TheClientChoiceTable
  }
})
export default class TheClientDecision extends Vue {
  @kycFormStore.State
  kycForm!: KYCForm;

  @inject()
  private projectInfo: IProjectInfo;

  personalDetails (clientIndex: 0 | 1) {
    if (clientIndex === 0) {
      return this.kycForm.client1.personalDetails
    } else {
      return this.kycForm.client2.personalDetails
    }
  }

  get totalAnnualPremiumForClient1 () {
    const annualPremium = this.kycForm.recommendations.totalAnnualizedPremiumForClient(0)
    return annualPremium ? annualPremium.toLocaleString() : 0
  }

  get totalSinglePremiumForClient1 () {
    const singlePremium = this.kycForm.recommendations.totalSinglePremiumForClient(0)
    return singlePremium ? singlePremium.toLocaleString() : 0
  }

  get totalAnnualPremiumForClient2 () {
    const annualPremium = this.kycForm.recommendations.totalAnnualizedPremiumForClient(1)
    return annualPremium ? annualPremium.toLocaleString() : 0
  }

  get totalSinglePremiumForClient2 () {
    const singlePremium = this.kycForm.recommendations.totalSinglePremiumForClient(1)
    return singlePremium ? singlePremium.toLocaleString() : 0
  }

  get clientDeclaration () {
    return this.kycForm.clientDeclaration
  }

  get sharedBasisAttribute () {
    return this.kycForm.client1.recommendationBasis
  }

  get recommendations () {
    return this.kycForm.recommendations
  }

  get rcmds () {
    return this.recommendations.flatProductWithInvestMainAccount
  }

  get nameList () {
    return this.kycForm.getLifeAssured()
  }

  get clientDisagreeWithRecommendation () {
    return this.clientDeclaration.clientDecisionAgree
  }

  set clientDisagreeWithRecommendation (value) {
    this.clientDeclaration.clientDecisionAgree = value
  }
}
